import { Group, Text } from '@mantine/core';

import { useFieldWarning } from './fieldWarnings.js';
import { useRegisterFieldTab } from './fieldTabRegistry.js';
import { WARNING_COLOR, WARNING_ICON } from './validatedFields.js';

interface FieldWarningNoteProps {
  /**
   * Der Pfad, unter dem der Hinweis im Warnungs-Store steht. Fuer Hinweise, die einer
   * Feldgruppe gelten statt einem Feld, ist das ein Ankerpfad ohne eigenes Eingabefeld
   * (z. B. `noxMeasures`) -- er wird vom Backend-Constraint gesetzt und existiert nur als
   * Aufhaenger fuer diese Anzeige.
   */
  field: string;
}

/**
 * Zeigt einen Hinweis der gelben Stufe als dauerhaft sichtbare Zeile -- fuer Hinweise, die zu
 * keinem einzelnen Eingabefeld gehoeren.
 *
 * Warum nicht der Tooltip der Feldkomponenten: der zeigt seinen Text beim Hovern ueber dem
 * markierten Feld. Ein Gruppenhinweis hat kein solches Feld, es gaebe also nichts zu hovern --
 * und eine der Checkboxen einzufaerben hiesse, ein Kaestchen als auffaellig zu markieren, das
 * fuer sich genommen nicht falsch ist.
 *
 * Die Anmeldung am Reiter passiert VOR dem fruehen `return`: der Reiterpunkt soll auch dann
 * erscheinen, wenn der Melder den Reiter noch nie geoeffnet hat -- also gerade dann, wenn hier
 * (noch) nichts zu rendern ist.
 */
export function FieldWarningNote({ field }: FieldWarningNoteProps) {
  useRegisterFieldTab(field);
  const warning = useFieldWarning(field);

  if (!warning) return null;

  return (
    <Group gap={6} wrap="nowrap" align="flex-start" mb="sm">
      {WARNING_ICON}
      <Text size="sm" c={WARNING_COLOR}>
        {warning}
      </Text>
    </Group>
  );
}
